import crypto from "crypto";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
export default class Rememberme {
  constructor() {
    var _config$rememberme$re, _config$rememberme$re2, _config$rememberme$re3, _config$rememberme;
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$rememberme$re = config.rememberme.redis) === null || _config$rememberme$re === void 0 ? void 0 : _config$rememberme$re.host),
      port: process.env.REDIS_PORT || ((_config$rememberme$re2 = config.rememberme.redis) === null || _config$rememberme$re2 === void 0 ? void 0 : _config$rememberme$re2.port),
      keyPrefix: config.rememberme.redis.prefix,
      db: (_config$rememberme$re3 = config.rememberme.redis) === null || _config$rememberme$re3 === void 0 ? void 0 : _config$rememberme$re3.db
    }, (_config$rememberme = config.rememberme) === null || _config$rememberme === void 0 || (_config$rememberme = _config$rememberme.redis) === null || _config$rememberme === void 0 ? void 0 : _config$rememberme.cluster);
  }
  async save(id, payload) {
    const encryptedData = encrypto(JSON.stringify(payload));
    const [err, results] = await this.redis.multi().set(id, encryptedData).expire(id, config.token.maxAge).exec();
    console.log(err, results);
  }
  async refresh(id) {
    await this.redis.expire(id, config.token.maxAge);
  }
  async get(key) {
    const data = await this.redis.get(key);
    const decryptedData = decrypto(data);
    return JSON.parse(decryptedData);
  }
  async delete(key) {
    await this.redis.del(key);
  }
}
function encrypto(data) {
  const settings = config.rememberme.crypto;
  const key = crypto.scryptSync(settings.password, settings.salt, 32);
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv(settings.algo, key, iv);
  let encryptedData = cipher.update(data);
  encryptedData = Buffer.concat([encryptedData, cipher.final()]);
  return Buffer.concat([iv, encryptedData]).toString("hex");
}
function decrypto(encryptedData) {
  const buffer = Buffer.from(encryptedData, "hex");
  const iv = buffer.slice(0, 16);
  const data = buffer.slice(16);
  const settings = config.rememberme.crypto;
  const key = crypto.scryptSync(settings.password, settings.salt, 32);
  const decipher = crypto.createDecipheriv(settings.algo, key, iv);
  let decryptedData = decipher.update(data);
  decryptedData = Buffer.concat([decryptedData, decipher.final()]);
  return decryptedData;
}